import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import {
  DEFAULT_OFFSET,
  PAGE_SIZE,
} from "../../../../clients/api-constants.js";
import InstrumentsHeader from "./components/header.js";
import CalibrationBody from "./components/body.js";
import { useNavigate, useParams } from "react-router-dom";
import { getEquipmentsApi, deleteInstrumentApi } from "../../apiCalls/calibrationApis.js";
import { showToastSuccess, showToastError } from "../../../../common/toasters/toasterMessages";

export default function CalibrationTable() {
  const params = useParams();
  const navigate = useNavigate();

  const [calibrationItem, setCalibrationItem] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(PAGE_SIZE);
  const [totalCount, setTotalCount] = useState(0);
  const [offset, setOffset] = useState(DEFAULT_OFFSET);
  const [calibrationList, setCalibrationList] = useState([]);
  const [isDelayedFilterActive, setIsDelayedFilterActive] = useState(false)

  const toggleDelayFilter = (e) => {
    if (e) e.stopPropagation() // Only stop propagation when event is provided
    const newState = !isDelayedFilterActive
    setIsDelayedFilterActive(newState)
    // Call the appropriate handler based on the new state
    if (newState) {
      getEquipmentList("", 0, currentPageSize, newState)
    } else {
      getEquipmentList("", 0, currentPageSize, null)
    }
  }

  const getEquipmentList = async (
    value = "",
    offset = DEFAULT_OFFSET,
    limit = PAGE_SIZE,
    delayed,
  ) => {
    setIsLoading(true);
    let response = await getEquipmentsApi(value, offset, limit, delayed)
    if (!response.isError) {
      setCalibrationList(response?.data?.instruments);
      setTotalCount(response?.totalCount);
    }
    setIsLoading(false);
  };

  const handlePaginationChange = (page, pageSize) => {
    if (pageSize !== currentPageSize) {
      setCurrentPage(1);
      setOffset(0);
      setCurrentPageSize(pageSize);
      getEquipmentList("", 0, pageSize);
    } else {
      setOffset(currentPageSize * (page - 1));
      setCurrentPage(page);
      getEquipmentList("", currentPageSize * (page - 1), currentPageSize);
    }
  };

  let search;
  const searchInstruments = (value) => {
    value = value.trimStart();
    clearTimeout(search);
    search = setTimeout(() => {
      void getEquipmentList(value);
    }, 500);
  };

  const handleCalibrationClick = (record) => {
    setCalibrationItem(record?.instrument);
  };

  const onRefresh = () => {
    const newState = isDelayedFilterActive
    // Call the appropriate handler based on the new state
    if (newState) {
      getEquipmentList("", 0, currentPageSize, newState)
    } else {
      getEquipmentList("", offset, currentPageSize, null);
    }
  };

  const handleDeleteInstrument = async (instrumentId) => {
    setIsLoading(true);
    let response = await deleteInstrumentApi(instrumentId);
    if (!response.isError) {
      showToastSuccess(response.displayableMessage || "Instrument deleted successfully");
      // Refresh the list after deletion
      const newState = isDelayedFilterActive;
      if (newState) {
        getEquipmentList("", 0, currentPageSize, newState);
      } else {
        getEquipmentList("", offset, currentPageSize, null);
      }
    } else {
      showToastError(response.displayableMessage || "Error deleting instrument");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    void getEquipmentList("", DEFAULT_OFFSET, PAGE_SIZE);
  }, [calibrationItem]);

  return (
    <Container fluid={true}>
      <>
        <InstrumentsHeader searchInstruments={searchInstruments} toggleDelayFilter={toggleDelayFilter} isDelayedFilterActive={isDelayedFilterActive} />
        <hr />
        <CalibrationBody
          params={params}
          navigate={navigate}
          calibrationData={calibrationList}
          loading={isLoading}
          totalRecords={totalCount}
          currentPage={currentPage}
          currentPageSize={currentPageSize}
          onRefresh={onRefresh}
          onCalibrationClick={handleCalibrationClick}
          onPaginationChange={handlePaginationChange}
          setLoading={setIsLoading}
          onDeleteInstrument={handleDeleteInstrument}
        />
      </>
    </Container>
  );
}
